import React, { useState } from 'react';
import { InnoSelect, InnoSelectItem } from '@innomotics/innomotics-build-react-lib';

interface SelectProps<T> {
    label: string;
    value: T;
    values: T[];
    mapToString: (value: T) => string | JSX.Element;
    onSelect: (value: T) => void;
    dark?: boolean;
    disabled?: boolean;
    error?: (value: T) => boolean;
    required?: boolean;
    filled?: (value: T) => boolean;
    onReset?: () => void;
}

const Select = <T, >({ dark, disabled, error, label, required, value, values, mapToString, onSelect }: SelectProps<T>) => {
    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);


    const closeSelect = () => {
        setOpen(false);
    };

    const handleInputChange = async (event: CustomEvent<string>) => {        
        event.stopPropagation();
        onSelect(event.detail as T);
        closeSelect();
    };
        
    return (          
        <InnoSelect
            key={`select-${values.length}`}
            variant={dark ? 'dark' : 'light'}
            className='inno-select'
            label={label}
            disabled={disabled}
            required={required}
            error={Boolean(error && error(value))}
            value={value}
            onValueChanged={handleInputChange}
        >
            {values.map((x, i) => (
                <InnoSelectItem
                    key={i}
                    value={x}
                    label={mapToString(x)}
                >
                </InnoSelectItem>
            ))}
        </InnoSelect>
       
    ); 
};

export default Select;
